import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";

export default function AuditTrail() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    getDocs(query(collection(db, "activity_logs"), orderBy("timestamp", "desc"))).then((snapshot) => {
      setLogs(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
  }, []);

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h2>Audit Trail / Activity Log</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f7f7f7" }}>
            <th style={{ padding: 8, border: "1px solid #ddd" }}>Time</th>
            <th style={{ padding: 8, border: "1px solid #ddd" }}>User</th>
            <th style={{ padding: 8, border: "1px solid #ddd" }}>Action</th>
            <th style={{ padding: 8, border: "1px solid #ddd" }}>Entity</th>
            <th style={{ padding: 8, border: "1px solid #ddd" }}>Entity ID</th>
            <th style={{ padding: 8, border: "1px solid #ddd" }}>Details</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id}>
              <td style={{ padding: 8, border: "1px solid #ddd" }}>
                {log.timestamp && log.timestamp.toDate().toLocaleString()}
              </td>
              <td style={{ padding: 8, border: "1px solid #ddd" }}>{log.user}</td>
              <td style={{ padding: 8, border: "1px solid #ddd" }}>{log.action}</td>
              <td style={{ padding: 8, border: "1px solid #ddd" }}>{log.entity}</td>
              <td style={{ padding: 8, border: "1px solid #ddd" }}>{log.entityId}</td>
              <td style={{ padding: 8, border: "1px solid #ddd" }}>
                <pre style={{ margin: 0, fontSize: 12 }}>{JSON.stringify(log.details, null, 2)}</pre>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}